export default {
    turn : {
        account: "บัญชีสมาชิก",
        count: "จำนวนครั้งที่เหลืออยู่",
        history: "บันทึกรายการชิงรางวัล",
        time: "เวลาชิงรางวัล",
        EventsTime: "เวลากิจกรรม",
        EventsActivities: "กิจกรรม",
        to: "ถึง",
        prize: "รายการชิงรางวัล",
        status: "สถานะการแจกรางวัล",
        unpay:  "ยังไม่แจกจ่าย",
        payed:  "แจกจ่ายสำเร็จ",
        accountError: "ความผิดปกติของบัญชี",
        contact: "กรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์",
        zero: "จำนวนครั้งของการชิงรางวัลที่เหลืออยู่คือ 0",
        drawing: "กำลังดำเนินการชิงรางวัล.",
        congratulations: "ขอแสดงความยินดีที่ได้รับ",
        activityEnds: 'กิจกรรมสิ้นสุดแล้ว',
        EndlookIt: 'โปรดติดตามกิจกรรมต่อไป',
        activityStart: 'กิจกรรมกำลังจะเริ่มขึ้น',
        EventsNotStart: 'กิจกรรมนี้ยังไม่ได้เริ่มขึ้น',
        UnderConstruction: 'กิจกรรมที่กำลังก่อสร้าง',
        StartlookIt: 'โปรดติดตาม!',
        EventsisEnd: 'กิจกรรมนี้สิ้นสุดแล้ว',
        ThanksJoin: 'ขอบคุณสำหรับการมีส่วนร่วมของคุณ!',
        AccountError: 'ความผิดปกติของบัญชี',
        DataError: 'ข้อมูลเสียหาย',
        TokenError: 'ข้อผิดพลาดในการตรวจสอบโทเค็น',
        drawCountEmpty: 'จำนวนครั้งในการชิงรางวัลไม่เพียงพอ'

    },
    awards: {
        "0": "1st",
        "1": "2nd",
        "2": "3rd",
        "3": "4th",
        "4": "5th",
        "5": "6th",
        "6": "7th",
        "7": "8th",
        "8": "9th",
        "9": "10th"
    },
    login: {
        title: 'Lucky Draw Station',
        logIn: 'Sign in',
        account: 'Account',
        password: 'Password'
    },

    navbar: {
        switchLang: "Language",
        home: 'Home',
        profile: 'Profile',
        logOut: 'Log Out',
        message: {
            hello: 'Hi, {msg}'
        }
    },

    level: {
        levelId:  "No. Pool",
        totalBet: "Total Rolloer"
    },
    award: {
        awards: "Phần thưởng",
        rate:   "Winning Odds",
        level:  "Pool "
    },
    awardLimit: {
        award:     "Phần thưởng",
        remaining: "Remain Prizes",
        limit:     "Total Prize",
        unlimit:   "Unlimited"
    },
    userInfo: {
        all:        "ทั้งหมด",
        platform:   "แพลตฟอร์ม",
        account:    "บัญชีสมาชิก",
        count:      "จำนวนการชิงรางวัลที่มีอยู่",
        totalCount: "ยอดเทิร์นโอเวอร์ทั้งหมด",
        totalBet:   "ทั้งหมด",
        level:      "เกณฑ์"
    },
    winningRecord: {
        all:          "ทั้งหมด",
        account:      "บัญชีสมาชิก",
        winningTime:  "เวลาที่ชนะ",
        platform:     "แพลตฟอร์ม",
        award:        "รางวัล",
        status:       "สถานะการแจกรางวัล",
        action:       "ดำเนินงาน",
        unpay:        "ยังไม่แจกจ่าย ",
        payed:        "แจกจ่ายสำเร็จ",
        pay:          "การกระจาย",
        previousPage: "หน้าก่อนหน้านี้",
        nextPage: "หน้าต่อไป",
        page: "หน้า {page}",
    },

    button: {
        search: "ค้นหา"

    },

    status: {
        update: {
            success: "การค้นหาสำเร็จ",
            error: "การค้นหาล้มเหลว",
        }
    },

   router: {
        level: "Rollover Setting",
        award: "Phần thưởng",
        awardLimit: "Prizes",
        userInfo: "Winner Record",
        winningRecord: "Prizes Record",
        dashboard: "Home"
    },

    //擴充自定義原element-ui的設定名稱
    elementUI: {
        datepicker: {
            rangeSeparator: "To",
            startMonth: "StartMonth",
            endMonth: "EndMonth",
        },
        confirm :{
            check: "Are you sure to claim?",
            tips: "Hint",
            confirm: "Confirm",
            cancel: "Cancel",
            canceled: "Cancelled",
        }
    },

    validator: {
        required: "Required",
    },
}



// WEBPACK FOOTER //
// ./src/lang/thai.js